export default __webpack_public_path__ + "static/media/Western_Balkans.fb5f4261.png";